<template>
  <div>
    <v-card class="text-xs-center">
      <h1 class="text-pagename">Tier Benefits Management</h1>
      <v-tabs fixed-tabs background-color="indigo">
        <v-tab
          v-for="(item, index) in AllLevels"
          :key="index"
          v-on:click="changeTap(item.level_id)"
        >
          {{ item.level_name }}
        </v-tab>
        <v-tab-item v-for="(item, index) in AllLevels" :key="index">
          <div class="text-xs-center" style="position:relative">
            <div style="height:20px">
              <CreateButton
                :level_id="item.level_id"
                style="position:absolute; right:5%;"
              />
            </div>

            <RankManagement :levelBenefit="AllLevelBenefitsByLevelId" />
          </div>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RankManagement from "../../../components/back-office/TierBenefitsManage/RankManagement";
import CreateButton from "../../../components/back-office/TierBenefitsManage/CreateButton";
export default {
  components: {
    RankManagement,
    CreateButton,
  },
  data() {
    return {
      tap: 1,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      AllLevels: (state) => state.tierBenefits.AllLevels,
      AllLevelBenefitsByLevelId: (state) =>
        state.tierBenefits.AllLevelBenefitsByLevelId,
    }),
  },
  async created() {
    await this.$store.dispatch("tierBenefits/getAllLevels");
    await this.$store.dispatch(
      "tierBenefits/getAllLevelBenefitsByLevelId",
      this.tap
    );
  },
  methods: {
    async changeTap(val) {
      this.tap = val;
      await this.$store.dispatch(
        "tierBenefits/getAllLevelBenefitsByLevelId",
        this.tap
      );
    },
  },
};
</script>

<style scoped></style>
